import { render, staticRenderFns } from "./QueueTemplateDetailView.vue?vue&type=template&id=6189b1ac&"
import script from "./QueueTemplateDetailView.vue?vue&type=script&lang=js&"
export * from "./QueueTemplateDetailView.vue?vue&type=script&lang=js&"
import style0 from "./QueueTemplateDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports